export default __webpack_public_path__ + "static/media/home-vigilance-section.1732b6e8.jpg";